import constants from './constants';

const { NAMESPACE } = constants;

const DELETE_FILE = `${NAMESPACE}/DELETE_FILE` as const;

const FETCH_FILES = `${NAMESPACE}/FETCH_FILES` as const;

export default {
  DELETE_FILE,
  FETCH_FILES,
};
